// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XFnY","title":"Info_title__1w4Fq","selects":"Info_selects__2fanp","requiredAsterisk":"Info_requiredAsterisk__2FQ55"};